module.exports = __webpack_public_path__ + "img/icon-arrow-drop-down.7f6b73ae.svg";